import React from "react";
export const AppTimeline = ({
  items,
  className,
  colorLine = "bg-white",
  widthLine = "w-[168px]",
  heigthLine = "h-12",
  widthFirstItem = "w-[90px]",
  widthSecondItem = "w-[60px]"
}) => {
  return (
    <div
      className={`max-w-6xl mx-auto overflow flex justify-between place-items-center flex-col xl:flex-row ${className}`}
    >
      {items.map((item, index) => (
        <div key={index} className="flex items-center xl:flex-col gap-6 w-fit">
          <div className={`xl:text-xl uppercase text-end lg:text-center ${widthFirstItem}`}>
            {item[0]}
          </div>
          <div className="relative">
            <span
              className={`xl:hidden absolute left-1/2 -translate-x-1/2 w-[1px] ${colorLine} 
              ${
                item[0].props.id === "last-item" ? "h-0" : heigthLine
              }
              
              `}
            />
            <span
              className={`hidden xl:block absolute -translate-y-1/2 h-0.5  ${colorLine} ${
                item[0].props.id === "last-item" ? "w-0" : widthLine
              }`}
            />
            <span className="block absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-2 h-2 bg-secondary" />
          </div>
          <div className={`xl:w-[160px] uppercase xl:text-md text-start xl:text-center font-bold ${widthSecondItem}`}>
            {item[1]}
          </div>
        </div>
      ))}
    </div>
  );
};
